export const SET_NOTIFICATION_RESOLVED_PARAMS = 'EMAIL/SET_NOTIFICATION_RESOLVED_PARAMS';
export const RESOLVE_NOTIFICATION_PARAMS = 'EMAIL/RESOLVE_NOTIFICATION_PARAMS';



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/resolvedParams/actionTypes.js